module.exports = __webpack_public_path__ + "static/img/yt.df325a7b.svg";